import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { Flecha } from './iconos';

/**
 * Volver a la vista anterior. Portado de Polaris, con la marca de Copathy.
 *
 * ── Por qué es un botón y no un enlace de texto ──
 * Estaba como «← Clientes» en texto plano. Un texto con una flecha delante se
 * lee como una decoración: no se ve que sea accionable hasta que uno le pasa el
 * mouse por encima, y en móvil no hay «pasar por encima». Un control con borde,
 * fondo y área de toque se reconoce sin tener que probarlo.
 *
 * Sigue siendo un `<Link>` por dentro —conserva el clic derecho, «abrir en otra
 * pestaña» y el prefetch del router—; lo que cambia es que se ve como lo que es.
 */
export function BotonVolver({ a, children }: { a: string; children: ReactNode }) {
  return (
    <Link
      to={a}
      className="inline-flex items-center gap-2 rounded-2xl border border-marino-200 bg-white
        px-4 py-2.5 text-sm font-semibold text-marino-600 shadow-[var(--sombra-sm)] transition
        hover:border-marino-400 hover:text-marino-800
        focus:outline-none focus-visible:ring-4 focus-visible:ring-marino-700/15"
    >
      <Flecha size={16} /> {children}
    </Link>
  );
}
